import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackRouteChange } from '../lib/feTelemetry';

export default function StudentRouteActivityTracker(): null {
  const location = useLocation();

  useEffect(() => {
    trackRouteChange(location.pathname);
  }, [location.pathname]);

  return null;
}
